type SolidgateFormStyles = Record<string, unknown>;

export function buildInlinePaymentFormStyles(
  isDark: boolean,
): SolidgateFormStyles {
  const borderColor = isDark ? 'rgba(255,255,255,0.12)' : '#e0e0e0';
  const bg = isDark ? 'rgba(255,255,255,0.06)' : '#fff';
  const textColor = isDark ? '#ffffff' : '#181B29';
  const placeholder = isDark ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.35)';
  const focusedPlaceholder = isDark
    ? 'rgba(255,255,255,0.7)'
    : 'rgba(0,0,0,0.45)';
  const focusBg = isDark ? 'rgba(59,113,247,0.12)' : 'rgba(59,113,247,0.05)';
  const errorLabelColor = isDark ? 'rgba(255,255,255,0.85)' : '#2C3246';

  const inputBase = {
    border: `2px solid ${borderColor}`,
    padding: '16px 20px',
    height: '52px',
    'font-size': '15px',
    color: textColor,
    background: bg,
    'font-weight': '500',
    'font-family': 'Inter, sans-serif',
    ':focus': { 'border-color': '#3b71f7', background: focusBg },
    '::placeholder': { color: placeholder },
    ':focus::placeholder': { color: focusedPlaceholder },
  };

  const errorTooltip = {
    'z-index': 4,
    background: '#E15E5E',
    color: 'white',
    'border-radius': '6px',
    'font-weight': '500',
    'font-size': '10px',
    padding: '6px 12px',
    'text-align': 'center',
    margin: '0 auto',
    top: '46px',
    left: '50%',
    transform: 'translate(-50%)',
    'min-width': '150px',
    'line-height': '150%',
    'letter-spacing': '-0.2px',
    position: 'absolute',
  };

  const errorTriangle = {
    content: '',
    position: 'absolute',
    top: '-6px',
    left: '50%',
    transform: 'translate(-50%)',
    width: 0,
    height: 0,
    margin: '0 auto',
    'border-style': 'solid',
    'border-width': '0 6px 8px',
    'border-color': 'transparent transparent #E15E5E',
    '.text': { display: 'none' },
  };

  const errorInput = {
    '.error input': {
      border: '2px solid #E15E5E',
      background: 'rgba(225, 94, 94, 0.1)',
    },
    '.error .label': {
      color: errorLabelColor,
      '::after': { content: 'none' },
    },
    '.error-text': errorTooltip,
    '.triangle': errorTriangle,
  };

  return {
    form_body: {
      'form-container': { 'padding-top': '0' },
      '.two-columns': {
        margin: '0',
        'grid-template-columns': 'repeat(2, calc(50%))',
        'grid-column-gap': '0',
        input: { 'border-radius': '0 0 12px 0' },
        '.expiry_date': { input: { 'border-radius': '0 0 0 12px' } },
      },
    },
    card_number: {
      ...errorInput,
      '.label': { display: 'none' },
      '.brand-icon': {
        top: '50%',
        transform: 'translateY(-50%)',
        left: '16px',
        right: 'unset',
      },
      '.error-text': { ...errorTooltip, 'min-width': '280px' },
      input: { ...inputBase, 'border-radius': '12px 12px 0 0' },
    },
    expiry_date: {
      ...errorInput,
      '.label': { display: 'none' },
      input: { ...inputBase },
    },
    card_cvv: {
      ...errorInput,
      '.label': { display: 'none' },
      '.tooltip-icon': { display: 'none' },
      input: { ...inputBase },
    },
    cardholder_name: {
      ...errorInput,
      '.label': { display: 'none' },
      input: {
        ...inputBase,
        'border-radius': '0 0 12px 12px',
        'border-top': 'none',
      },
    },
    submit_button: {
      'border-radius': '100px',
      display: 'block',
      padding: '14px',
      margin: '16px 0 0',
      height: 'auto',
      'background-color': '#3b71f7',
      cursor: 'pointer',
      '.title': {
        'font-weight': '600',
        'font-family': 'Inter, sans-serif',
        'font-size': '15px',
        'line-height': '22px',
        color: '#fff',
      },
      '.title-icon': { display: 'none' },
    },
  };
}
